//@import dependencies
import React, { useState, useEffect} from 'react'
//@end

//@import components
import SchedulingFormModule from 'app_components/modules/admin/landings/schedulingForm/index';
import DescriptivetrainingformModule from 'app_components/modules/admin/landings/descriptivetrainingform';
import OurClientsFormModule from 'app_components/modules/admin/landings/ourClientsForm/index';
import ReferenceFormModule from 'app_components/modules/admin/landings/referencesForm/index';
//@end

// @import hooks
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form';
import { useColors } from 'app_hooks/useColors';
// @end

// @INFO Import types
import { ILanding } from 'app_types/admin/landings/landingTypes';
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../businessLandingModule.scss'

// @ADD Component types
interface IBusinessLandingModuleLayoutProps {
  permission: any
  landingInfo: ILanding | null
  loadingForm: 'loading' | null
  onHandleSchedulingSubmit: (data: any) => void | null
  onHandleGeneralInfoSubmit: (data: any) => void | null
}

const BusinessLandingModuleLayout: React.FC<IBusinessLandingModuleLayoutProps> = (props) => {

  const [colors] = useColors()
  const generalInfoFormHook = useForm()

  const [listOfSchedulings, setListOfSchedulings] = useState<Array<any>>([])

  const { t } = useTranslation()

  useEffect(() => {
    let schedulings: Array<any> = []
    if (props.landingInfo?.landing?.scheduling && props.landingInfo?.landing?.scheduling.length > 0) {
      schedulings = props.landingInfo?.landing?.scheduling
    }
    setListOfSchedulings(schedulings)
  }, [props.landingInfo?.landing?.scheduling])

  return(
    <div className='business_landing-module'>
      {/* ======== Titulo e imagen principal ============= */}
      {/* <div className="d-flex align-items-center mb-2">
        <h3 className="form-title">{t("modules.teacher_landing_form.sections.general_information")}</h3>
      </div>

      <form
        onSubmit={generalInfoFormHook.handleSubmit(props.onHandleGeneralInfoSubmit)}
        className="form-general-info"
      >
        <div className="row">
          <div className="col-8">
            <div className='form-group '>
              <label htmlFor='title_page'>{t('labels.teacher_landing_form.title_page')}</label>
              {generalInfoFormHook.errors.title_page && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              <input
                id='title_page'
                name='title_page'
                className={`form-control ${generalInfoFormHook.errors.title_page && 'is-invalid'}`}
                type='text'
                ref={generalInfoFormHook.register({ required: true })}
                defaultValue={props?.landingInfo?.landing?.title_page}
              />
            </div>
          </div>
          {props.permission.checkSimple('permission:landings_business_general_info') && (
            <div className="col-4 button-right">
              <button className='btn btn-primary button-with-spinner' type='submit' disabled={props.loadingForm === 'loading'}>
                {props.loadingForm === 'loading' && (
                  <>
                    <div className="spinner-border spinner-loading-button" role="status"></div>&nbsp;&nbsp;
                  </>
                )}
                {t('buttons.save')}
              </button>
            </div>
          )}
        </div>
      </form> */}

      {/* ========== Formación descriptiva =============== */}
      <DescriptivetrainingformModule
        data={props.landingInfo?.landing?.descriptive_training}
        source='business'
        onHandleDescriptiveTrainingSaved={props.onHandleSchedulingSubmit}
      />

      {/* ========== Nuestras referencias =============== */}
      <ReferenceFormModule
        data={props.landingInfo?.landing?.references}
        source='business'
        onHandleSaved={props.onHandleSchedulingSubmit}
        landingInfo={props.landingInfo}
      />

      {/* ========== Nuestros clientes =============== */}
      {/* <OurClientsFormModule
        data={props.landingInfo?.landing?.our_clients}
        source='business'
        onHandleOurClientSaved={props.onHandleSchedulingSubmit}
      /> */}

      {/* ========== Programación en linea =============== */}
      <SchedulingFormModule
        source='business'
        listOfSchedulings={listOfSchedulings}
        onHandleSchedulingSubmit={props.onHandleSchedulingSubmit}
      />
    </div>
  )
}

export default BusinessLandingModuleLayout
